import {AppSettingsRepo, SettingsKeys} from "../../domain/settings/IAppSettingsRepo";

const getAuthToken = async () => {
    return await AppSettingsRepo.get(SettingsKeys.authToken);
}

export default getAuthToken;